/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_OverviewInputs */

const en_us2_profile_overview = /** @type {(inputs: Profile_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const pt_br2_profile_overview = /** @type {(inputs: Profile_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral`)
};

const es_419_profile_overview = /** @type {(inputs: Profile_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen`)
};

const pt_pt2_profile_overview = /** @type {(inputs: Profile_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral`)
};

const fr_fr2_profile_overview = /** @type {(inputs: Profile_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vue d'ensemble`)
};

const de_de2_profile_overview = /** @type {(inputs: Profile_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersicht`)
};

const it_it2_profile_overview = /** @type {(inputs: Profile_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panoramica`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Profile_OverviewInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_overview = /** @type {((inputs?: Profile_OverviewInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_OverviewInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_overview(inputs)
	if (locale === "es-419") return es_419_profile_overview(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_overview(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_overview(inputs)
	if (locale === "de-DE") return de_de2_profile_overview(inputs)
	if (locale === "it-IT") return it_it2_profile_overview(inputs)
	return en_us2_profile_overview(inputs)
});
export { profile_overview as "profile.overview" }